<div class="fdx-c-modal">
    <div class="fdx-c-modal__backdrop"></div>
    <div class="fdx-c-modal__main fdx-c-box-rounded" [ngClass]="{
        'fdx-c-modal__main--small': modalDialogType==='SMALL',
        'fdx-c-modal__main--medium':modalDialogType==='MEDIUM',
        'fdx-c-modal__main--large':(modalDialogType==='LARGE'),
        'fdx-c-modal__main--full-height': modalDialogType==='FULL_HEIGHT',        
        'fdx-c-modal__main--': modalDialogType==='DEFAULT'
      }">
        <div class="fdx-c-modal__body" [ngClass]="{'text-center': confirmlayoutAlign === 'center', 'text-left': confirmlayoutAlign === 'left' }">
            <h3 class="fdx-c-modal__title" [hidden]="showTitle"> {{modalDialogHeaderContent}}</h3>
            <a [hidden]="showCancelButton" class="fdx-u-mr--2 fdx-modal-close-icon" (click)="raiseModalEvent('cancel')">
                <div class="none">
                    <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                        <use xlink:href="#status_circle_close"></use>
                    </svg>
                </div>
            </a>

            <div class="fdx-c-modal__description" [ngClass]="textContentStyle" [innerHTML]="modalDialogBodyContent">
            </div>

            <div class="fdx-o-grid__item fdx-o-grid__item--12" *ngIf="modalDropDownFieldData !== ''">
                <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--has-value" [ngClass]="{
                    'fdx-c-form-group--is-invalid': !dropDownVal.valid && dropDownVal.touched && dropDownVal.hasError('required'),
                    'fdx-c-form-group--has-value': dropDownVal.value !== null && dropDownVal.value !== '' }">
                    <span class="fdx-c-form-group__item" [ngClass]="{
                            'fdx-c-form-group--is-invalid': !dropDownVal.valid && dropDownVal.touched && dropDownVal.hasError('required'),
                        'fdx-c-form-group--has-value': dropDownVal.value !== null && dropDownVal.value !== '' }">
                        <select #select id="dropDownVal" [formControl]="dropDownVal" class="fdx-c-form-group__select">
                            <option label="{{ 'APP.AppOption_Select' | translate: {Default: 'Select'} }}" value="" selected="">
                                {{"APP.AppOption_Pleaseselect" | translate: {Default: "Please Select"} }}
                            </option>
                            <option *ngFor="let units of modalDropDownFieldData" [value]="units.lookupCode">
                                {{units.lookupCodeDescription}}
                            </option>
                        </select>
                        <div class="fdx-c-form-group__icon">
                            <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                                <use xlink:href="#chevron"></use>
                            </svg>
                        </div>
                        <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc " for="dropDownVal">
                            <span class="fdx-c-content" translate>
                                {{"COMMON.CommonConfirmmodalInput_Pleaseselectareason" | translate: {Default: "Please select a reason"} }}
                            </span>
                        </label>
                    </span>
                    <div role="alert" class="fdx-c-form-group__message fdx-c-form-message--error" *ngIf="!dropDownVal.valid && dropDownVal.touched && dropDownVal.hasError('required')" translate>
                        {{"COMMON.CommonConfirmmodalErrmsg_Pleaseselectareason" | translate: {Default: "Please select a reason"} }}
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div *ngIf="confirmButtonType === ''" class="fdx-u-mt--4 fdx-u-mb--4 align-items-center" [ngClass]="buttonContentStyle">
                        <button [hidden]="showCancelButton" class="fdx-c-button fdx-c-button--text fxg-margin-right" (click)="raiseModalEvent('cancel')" translate>
                            {{"APP.AppButton_Cancel" | translate: {Default: "CANCEL"} }}
                        </button>
                        <button *ngIf="showLinkButton !== ''" (click)="raiseModalEvent('link')" class="fdx-c-button fdx-c-button--primary fxg-margin-right" translate>
                            {{modalLinkButtonVal}}
                        </button>
                        <button *ngIf="showSubmitButton === ''" [hidden]="showLoadingButton" (click)="raiseModalEvent('submit')" class="fdx-c-button fdx-c-button--primary fxg-margin-right" translate>
                            {{modalButtonVal}}
                        </button>
                        <button [hidden]="!showLoadingButton" class="fdx-c-button fdx-c-button--primary fdx-c-button--min-width fdx-c-button--loading loading-btn-post" aria-label="Continue" disabled="disabled">
                            <span class="fdx-c-button__title" hidden translate>
                                {{"APP.AppButton_Continue" | translate: {Default: "Continue"} }}
                            </span>
                            <span class="fdx-c-button__loading">
                                <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                                    <div class="fdx-c-loading-indicator__part"></div>
                                    <div class="fdx-c-loading-indicator__part"></div>
                                    <div class="fdx-c-loading-indicator__part"></div>
                                    <div class="fdx-c-loading-indicator__part"></div>
                                </div>
                            </span>
                        </button>
                        <button *ngIf="thirdBtnShow" (click)="raiseModalEvent('No')" class="fdx-c-button fdx-c-button--text fxg-margin-right" translate>
                            {{modalButtonForThirdBtn}}
                        </button>
                    </div>
                    <div *ngIf="confirmButtonType === 'YESNO'" class="fdx-u-mt--4 fdx-u-mb--4 d-flex w-100 align-items-center align-middle justify-content-center" [ngClass]="buttonContentStyle">
                        <button [hidden]="showLoadingButton" (click)="raiseModalEvent('no')" class="fdx-c-button fdx-c-button--primary fxg-margin-right" translate>
                            {{modalNoButtonVal}}
                        </button>
                        <button [hidden]="showYesLoadingButton" (click)="raiseModalEvent('yes')" class="fdx-c-button fdx-c-button--primary fxg-margin-right" translate>
                            {{modalYesButtonVal}}
                        </button>
                        <button [hidden]="!showYesLoadingButton" class="fdx-c-button fdx-c-button--primary fxg-margin-right" translate>
                            <span class="fdx-c-button__loading">
                                <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                                    <div class="fdx-c-loading-indicator__part"></div>
                                    <div class="fdx-c-loading-indicator__part"></div>
                                    <div class="fdx-c-loading-indicator__part"></div>
                                    <div class="fdx-c-loading-indicator__part"></div>
                                </div>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>